/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class BasicClassCountsRoute extends Route {
  // Services
  @service
  schoolSchema;

  @service
  store;

  // State
  year = moment().format('YYYY');

  model() {
    return hash({
      people: this.store.query('person', { type: PersonType.LEARNER }),
      homerooms: this.store.query('group', {
        groupType: GroupType.HOMEROOM,
        year: this.year,
      }),
      genderField: this.schoolSchema.getLearnerGenderField(),
    });
  }
}
